import styled from 'styled-components';
//
import colors from 'theme/colors';

const { darkInputBorder } = colors;

export default styled.textarea({
  height: 105,
  padding: '12px 13px',
  width: '-webkit-fill-available',
  fontSize: '14px',
  border: `1px solid ${darkInputBorder}`,
  borderRadius: 2,
  fontFamily: 'inherit',
});
